import { ReactNode } from 'react'
import AsyncSelect from 'Shared/components/AsyncSelect'
import { useAct } from 'DashboardBuilder/store'
import './Users.scoped.scss'

// eslint-disable-next-line react/prop-types
export function UsersShortDescriptor({
  dashboardScope,
  groups,
}: {
  dashboardScope: ReactNode
  groups: {
    name: string
  }[]
}) {
  const groupNames = groups.map((g) => g.name).join(', ')
  return groups.length === 0 ? (
    <p className="no-margin-bottom">
      Currently no one can use this Dashboard. Add one or more user groups to grant access.
    </p>
  ) : (
    <p>
      Anyone within the user groups <span className="bold">{groupNames}</span>, who is
      within <span className="bold">{dashboardScope}</span> or any sub-organisation, can
      use this dashboard.
    </p>
  )
}

function GroupsList({ groups }) {
  const act = useAct()

  return  <>
    {groups.map((group) => {
      return (
        <p key={group.id} className="group-item">
          {group.name}{' '}
          <a
            className="button smallest red"
            onClick={() => act.dashboard.removeGroup(group.id)}
          >
            Remove
          </a>
        </p>
      )
    })}
  </>
}

export default () => {
  const act = useAct()
  const { id, groups, scope } = useSel((s) => s.dashboard)

  return (
      <div className="row">
        <div className="column remaining">
          <div className="field">
            {groups.length === 0 && (
              <p className='incomplete no-margin-bottom'>Who can use this dashboard?</p>
            )}
            {groups.length > 0 && (
              <p>
                Users in <span className="bold">{scope}</span> or any sub-organisation,
                who belong to one of the following groups:
              </p>
            )}
            <div className='groups-list margin-top half'>
              <GroupsList groups={groups} />
            </div>
          </div>
          <div className="field">
            <label>Add a user group who can use the dashboard</label>
            <AsyncSelect
              entity="group"
              loadStaticList={true}
              getOptionLabel={(v) => v.name || v.label}
              queryParameters={{
                exclude: groups.map((g) => g.id),
              }}
              onChange={(_, group) => {
                act.dashboard.addGroup({ id: group.value, name: group.label })
              }}
            />
          </div>
        </div>
      </div>
  )
}
